import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';
import { HandoverHistoryQuery } from '../model/query/handover-history-query';
import { HandoverStatisticsQuery } from '../model/query/handover-statistics-query';
import { Query } from '../model/query/query';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for communicating with the Handover API endpoint.
@Injectable()
export class HandoverEndpointService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) {}

  HandoverHistoryQuery(queryData: HandoverHistoryQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.HandoverHistoryQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  HandoverStatisticsQuery(queryData: HandoverStatisticsQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.HandoverStatisticsQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  Sync(ifModifiedSince: string, isInitialLoad: boolean): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
    };

    return this.http.request(
      'GET',
      this.settingsService.getApiServiceBaseUrl() + 'Handover?ifModifiedSince=' + ifModifiedSince + '&isInitialLoad=' + isInitialLoad,
      options);
  }

  GetSingle(handoverId: string): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
    };

    return this.http.request(
      'GET',
      this.settingsService.getApiServiceBaseUrl() + 'Handover/' + handoverId,
      options);
  }
}
